module.exports = __webpack_public_path__ + "static/media/Chats.df120194.png";